import React from 'react'
import Section from '../components/Section'
import EthoLogo from '../assets/images/landing-page/etho-logo.png'
import Image from '../assets/images/landing-page/image.png'

class Landing2 extends React.Component {
	componentDidMount() {
		window.addEventListener('scroll', () => {
			window.scrollTo(0, 0)
		})
	}

	render() {
		return (
			<div className='main-container'>
				<Section
					id='landing-page__2'
					className='height-auto landing__container'>
					<div className='col-md-6'>
						<img
							src={Image}
							alt='happy female model wearing a dress'
						/>
					</div>
					<div className='col-md-6 text-center align-self-center'>
						<a href='/'>
							<img
								src={EthoLogo}
								alt='Etho logo with symbol and text'
							/>
						</a>
						<h1>The Curated</h1>
						<p className='text-justify'>
							Behind every great brand is a great woman: ours is
							Mother Erth. We do more than just sell unique,
							curated products from around the world, we change
							lives. We believe we&apos;re better together &mdash;
							join the movement by shopping sustainably with
							confidence at The Etho. We have done the work so you
							don&apos;t have to.
						</p>
						<a href='https://alegreea.com' className='btn'>
							<span className='btn__text'>Shop Now</span>
						</a>
					</div>
				</Section>
			</div>
		)
	}
}

export default Landing2
